import { z } from 'zod'

const phoneRegExp = new RegExp(/^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/)

const firstNameValidator = z
  .string()
  .trim()
  .min(1, { message: 'Please share your first name.' })
const lastNameValidator = z.string({
  required_error: 'Please share your last name.',
})

export const demoFormSchema = z.object({
  firstName: firstNameValidator,
  lastName: lastNameValidator,
  email: z.string().email({
    message: 'Invalid email address.',
  }),
  company: z.string({
    required_error: 'Please share the company.',
  }),
  agents: z.string({
    required_error: 'Please select how many agents are at your company.',
  }),
  industry: z.string({
    required_error: 'Please select an industry.',
  }),
  modules: z.array(z.string()).refine((value) => value.some((item) => item), {
    message: 'You have to select at least one module.',
  }),
  message: z.string({
    required_error: 'Please enter a valid message.',
  }),
})

export const contactFormSchema = z.object({
  firstName: firstNameValidator,
  lastName: lastNameValidator,
  email: z.string().email({
    message: 'Please enter a valid email address.',
  }),
  phone: z.union([
    z.string(),
    z.string().regex(phoneRegExp, { message: 'Please enter a valid phone number.' }),
  ]),
  company: z.string({
    required_error: `Please share your company's name.`,
  }),
  reason: z.string(),
  message: z.string({
    required_error: 'Please enter a valid message.',
  }),
})

export type DemoFormSchema = z.infer<typeof demoFormSchema>

export type ContactFormSchema = z.infer<typeof contactFormSchema>
